import { createUseStyles } from "react-jss";

export const ManagementParkingValidationRuleListColumnStyle = createUseStyles((theme: any) => ({
    header: {
        display: "flex",
    },
    sort: {
        marginTop: "5px",
    },
    iconSort: {
        fill: theme.colors.iconSort.disabled,
        width: "16px",
    },
    iconSorted: {
        fill: theme.colors.iconSort.enabled,
        width: "16px",
    },
    sortColumn: {
        width: 14,
        display: "flex",
        position: "absolute",
    },
    buttonsContainer: {
        display: "flex",
    },
    editIcon: {
        width: theme.widths.management.icons,
        cursor: "pointer",
        fill: theme.colors.palette.purple,
    },
    arrow : {
        color: theme.colors.table.sortArrow.color
    }
}));
